import { createContext, use } from "react";

import type { OrthoListItem } from "api/model";

import type { CogOrthoApi } from "./cogOrtho";
import type { OrthoImageOverlay } from "./orthoAssets";

export interface LocationOrtho extends OrthoListItem {
  isVisible: boolean;
  /** Folder the user selected for this flight's images, when the ortho list includes it. */
  user_folder?: string | null;
}

export interface CogOrthoSession {
  api: CogOrthoApi | null;
  error: Error | null;
  isPending: boolean;
  overlay: OrthoImageOverlay | null;
  /** Presigned COG URL; changes when the open session is disposed and reopened. */
  sessionKey: string | null;
}

export interface CogOrthoContextValue {
  orthos: LocationOrtho[];
  /** Presigned COG URL by ortho id, for every location ortho (not only visible ones). */
  presignedUrls: ReadonlyMap<number, string>;
  sessions: Readonly<Record<number, CogOrthoSession>>;
  displayOrtho: (orthoId: number | null) => void;
}

export const CogOrthoContext = createContext<CogOrthoContextValue | null>(null);

export const useCogOrtho = (): CogOrthoContextValue => {
  const context = use(CogOrthoContext);
  if (context == null) {
    throw new Error("useCogOrtho must be used within CogOrthoProvider");
  }
  return context;
};
